export default "__VITE_ASSET__Bo4O0zHd__"